import { render, staticRenderFns } from "./SmBadgeCategory.vue?vue&type=template&id=783e3830&scoped=true&"
import script from "./SmBadgeCategory.vue?vue&type=script&lang=ts&"
export * from "./SmBadgeCategory.vue?vue&type=script&lang=ts&"
import style0 from "./SmBadgeCategory.vue?vue&type=style&index=0&id=783e3830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783e3830",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
